import { ISectionLinks } from '@features/footer/typescript';
import GeneralList from '@features/footer/components/GeneralList';
import styles from '@features/footer/Footer.styles';
type PropsType = {
  sectionLinks: ISectionLinks;
};
const General = ({
  sectionLinks
}: PropsType) => {
  const links = sectionLinks ? Object.values(sectionLinks) : [];
  let index = 0;
  return <div sx={styles.footerGeneralContainer(links.length)}>
      {links.map(item => {
      index += 1;
      return <GeneralList key={index} section={item} index={index} />;
    })}
    </div>;
};
export default General;